"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerContainer = void 0;
var preact_1 = require("preact");
var styles = require("./_banner-container.scss");
var close_small_1 = require("./close-small");
var close_large_1 = require("./close-large");
var BannerContainer = /** @class */ (function (_super) {
    __extends(BannerContainer, _super);
    function BannerContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BannerContainer.prototype.render = function (props) {
        var _a = this.props.theme, backgroundColor = _a.backgroundColor, blur = _a.blur;
        return ((0, preact_1.h)("div", { className: styles.bannerContainerRoot, "aria-live": "polite" },
            (0, preact_1.h)("div", { style: "\n                background-color:".concat(backgroundColor, "; \n                backdrop-filter: blur(").concat(blur, ");\n             "), className: styles.bannerContainer },
                (0, preact_1.h)("button", { className: styles.closeButton, onClick: props.onClose },
                    (0, preact_1.h)(close_small_1.CloseSmall, { className: styles.small }),
                    (0, preact_1.h)(close_large_1.CloseLarge, { className: styles.large })),
                this.props.children)));
    };
    return BannerContainer;
}(preact_1.Component));
exports.BannerContainer = BannerContainer;
//# sourceMappingURL=banner-container.js.map